<template>
	<div class="help flex-center">
		<div class="gif-bg" id="menubox"></div>
		<div class="content-div flex-col gap67" style="z-index: 2;">
			<img class="close-btn" src="../../../static/image/lobby/close.png" @click="closeMenu"  />
			<div class="help-title font700 white">{{$t('菜单')}}</div>
			<div class="flex-item gap25">
				<div class="help-item flex-col flex-center" v-for="(i,index) in list" :key="index" @click="menuClick(i)">
					<div class="help-text font24 white font700">{{i.text}}</div>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	export default {
		computed: mapState({
			screenSize(state) {
				return state.screenSize;
			},
			common(state) {
				return state.common;
			}
		}),
		data() {
			return {
				list: [
        //   {
        //     text: this.$t('公告'),
        //     link: '',
        //     news:true
        //   },
          {
            text: this.$t('跨链桥'),
            link: 'https://neco.novaichain.com/#/'
          },
          {
            text: this.$t('SWAP交易'),
            link: 'https://swap.novaichain.com'
          },
		  {
            text: this.$t('铸造与销毁协议'),
            link: 'https://tab.neco.ltd/#/'
          },
		  {
            text: this.$t('智能体'),
            link: 'https://poe.com/NECO-Web3-V1.3.3'
          },
          // {
          //   text: this.$t('NECO社区电商'),
          //   link: 'https://web.neco.ltd/pages/passport/login'
          // }

				]
			}
		},
		mounted() {

      this.$nextTick(() => {

        let colorbg = new Color4Bg.BlurGradientBg({
          dom: 'menubox',
          colors: ['#1D4600', '#152900', '#005232', '#000f07'],
          loop: true
        })
      })

			// this.$nextTick(() => {
      //   let color1bg = new Color4Bg.BlurDotBg({
      //     dom: "helpBox",
      //     colors: ["#801300","#AE1E00","#D92800","#EB3131"],
      //     loop: true
      //   })
			// })

		},
    methods:{
      menuClick(i){
        if(i.link){
          window.open(i.link)
        }else if(i.news){
          this.emitNews()
        }
      },
      emitNews () {
        this.$parent.showMenu=false
        this.$parent.$refs.top.selectType=false
        this.$parent.showDownload=false
        this.$emit('emitNews')
      },
	  closeMenu(){
        this.$emit('closeMenu', false)
      }
    }
	}
</script>

<style scoped>
	@media screen and (max-width: 768px) {
		.help {
			width: 70% !important;
			padding: 110px 0 60px 0 !important;
			height: calc(100vh - 110px - 60px) !important;
			position: relative;
			z-index: 100 !important;
			display: flex;
			justify-content: space-between;
			align-items: center !important;
			overflow-y: auto;
			overflow-x: hidden;
		}

		.gif-bg {
			width: 70% !important;
		}

		.flex-item {
			display: flex;
			flex-direction: column;
			gap: 14px;
		}

		.help-item {
			padding: 16px 20px !important;
			width: calc(100% - 40px) !important;
			background-color: rgba(255,255,255,.16) !important;
			display: flex;
			flex-direction: row;
			gap: 28px !important;
			border: none;
			justify-content: flex-start;
		}

		.help-text {
			font-size: 16px !important;
			max-width: 100% !important;
			text-align: left !important;
		}
	}
	
	.help {
		width: 100%;
		height: 100vh;
		position: relative;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 3;
		display: flex;
		flex-direction: column;
		align-items: center;
		/* justify-content: center; */
		overflow-y: auto;
	}

	.video-background {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		overflow: hidden;
		z-index: 1;
	}

	.vedio-lobby {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.gap67 {
		gap: .67rem;
	}

	.help-title {
		font-size: .96rem;

	}

	.help-item {
		padding: .16rem .4rem;
		border-radius: .24rem;
		/*border: 1px solid rgba(76, 217, 100, 0.20);*/
		background: rgba(0, 0, 0, 0.30);
		gap: .24rem;
	}

	.help-item img {
		width: 1.2rem;
		height: 1.2rem;
	}

	.gif-bg {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 2;
	}

	.help-text {
		max-width: 1.2rem;
		text-align: center;
		white-space: break-spaces;
	}

	.content-div {
		width: calc(100% - 1.2rem);
		padding: 0 .16rem;
	}
  .top-logo{
    width: 136px;
    height: 43px;
    cursor: pointer;
  }
  .close-btn {
	width: 30px;
    height: 30px;
	position: absolute;
	top: 35px;
	right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/app-menu.vue